import {
  IGenerateStrategyProps,
  IStrategy,
  IStrikeData,
  Leg,
  ViewType,
} from "../../../types";
import { analyzePositions } from "../../analyzeProfits";

export const generateBullCallLadder = (
  params: IGenerateStrategyProps,
  data: IStrikeData[],
  strategies: IStrategy[],
  expiryDuration: number
): IStrategy[] => {
  for (let i = 0; i < data.length; i++) {
    for (let j = i + 1; j < data.length-1; j++) {
      for (let k = j+1; k < data.length-2; k++) {
        const legs: Leg[] = [
          {
            strikePrice: data[i].strikePrice,
            call: true,
            buy: false,
            quantity: -params.lotSize,
            price: data[i].CE?.lastPrice || 0,
          },
          {
            strikePrice: data[j].strikePrice,
            call: true,
            buy: true,
            quantity: params.lotSize,
            price: data[j].CE?.lastPrice || 0,
          },
          {
            strikePrice: data[k].strikePrice,
            call: true,
            buy: true,
            quantity: params.lotSize,
            price: data[k].CE?.lastPrice || 0,
          },
        ];
        const analysis = analyzePositions(legs);
        const approxMargin =
          legs[1].price * legs[1].quantity +
          legs[2].price * legs[2].quantity +
          params.marginBenefit;
        const strategy: IStrategy = {
          title:
            "Bull Call Ladder " +
            data[i].strikePrice +
            " - " +
            data[j].strikePrice +
            " - " +
            data[k].strikePrice,
          legs: legs,
          callBreakEven: analysis.breakEven.callBreakEven,
          callBreakEvenPercentage:
            ((analysis.breakEven.callBreakEven - params.data.underlyingValue) /
              params.data.underlyingValue) *
            100,
          maxLoss: analysis.maxLoss,
          maxProfit: analysis.maxProfit,
          riskRewardRatio: analysis.maxProfit / analysis.maxLoss,
          maxLossROI: (analysis.maxLoss / approxMargin) * 100,
          maxProfitROI: (analysis.maxProfit / approxMargin) * 100,
          approxMargin: approxMargin,
          expiryDuration: expiryDuration,
          lotSize: params.lotSize,
          types: [ViewType["Extremely Positive"]],
          alert:
            (analysis.maxLoss / approxMargin) * 100 > 15
              ? "Max loss greater than 15% of required capital"
              : "",
        };
        if (
          legs[0].price > 0 && //avoid non-liquid options
          legs[1].price > 0 &&
          legs[2].price > 0
        )
          strategies.push(strategy);
      }
    }
  }
  return strategies;
};
